angular.module('picmonicng').directive('infiniteScroll', [
  'LearnService',
  '$filter',
  '$window',
  function (LearnService, $filter, $window) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.offset = 0;
        scope.calc_offset = 0;
        scope.item_height = parseInt(attrs.itemHeight);

        var timeout;
        element.bind('scroll', function (event) {
          if (attrs.usePosition) {
            var container_offset = element.find('.infinite-container').position().top + scope.item_height;
          } else {
            var container_offset = element.find('.infinite-container').offset().top;
          }

          element.addClass('scrolling');
          scope.$apply(function () {
            scope.offset = Math.floor(Math.max(scope.item_height - container_offset, 0) / scope.item_height);
          });

          clearTimeout(timeout);
          timeout = setTimeout(function () {
            element.removeClass('scrolling');
          }, 150);
        });

        scope.setDimensions = function () {
          scope.limit = Math.ceil(element.height() / scope.item_height) + 5;
        };

        angular.element($window).bind('resize', function () {
          scope.setDimensions();
          scope.$apply();
        });

        scope.setDimensions();
      },
    };
  },
]);
